import styled from "styled-components";

import { frameTransparentBackground } from "components/common/backgroundFrame";
import { getHeadingTag } from "components/common/heading";
import { HeadingLevel } from "types/headingLevel";

interface Props {
    headingLevel?: HeadingLevel;
    // Lets the proposals or the field refer to the title (aria-labelledby)
    id?: string;
    title: string;
}

const TitleHeader = ({ headingLevel = 1, id, title }: Props) => {
    return (
        <WrapperHeader as={getHeadingTag(headingLevel)} id={id}>
            {title}
        </WrapperHeader>
    );
};

// A heading for the structure only (RGAA 9.1): it keeps the look of the former div.
const WrapperHeader = styled.h1`
    margin-top: 0;
    font-size: 1.2rem;
    font-weight: bold;
    background-color: #f5f5f5;
    font-size: 14px;
    padding: 0.75rem 0.5rem;
    margin-bottom: 1rem;
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    ${frameTransparentBackground}
`;

export default TitleHeader;
